import React from 'react';
import { Factory, Flame, Building2, Wrench, Cog, Package } from 'lucide-react';
import { Card } from './ui/card';

export const Industries = () => {
  const industries = [
    { icon: Flame, name: 'Refining' },
    { icon: Factory, name: 'Petrochemical' },
    { icon: Building2, name: 'Heavy Industrial Construction' },
    { icon: Package, name: 'Capital Projects' },
    { icon: Wrench, name: 'Turnaround & Outage Management' },
    { icon: Cog, name: 'Manufacturing Facilities' },
  ];

  return (
    <section id="industries" className="py-24 bg-[#0D1115] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Montserrat'] font-bold text-4xl sm:text-5xl text-[#F5F7F8] mb-6">
            INDUSTRIES WE <span className="text-[#30D5C8]">SERVE</span>
          </h2>
          <p className="text-[#CBD3D9] text-lg sm:text-xl font-['Open_Sans'] max-w-3xl mx-auto">
            Trusted by leaders in heavy industrial sectors
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, index) => (
            <Card
              key={index}
              className="bg-[#1A2733]/50 backdrop-blur-sm border-[#506273]/30 p-8 hover:border-[#30D5C8]/50 transition-all duration-300 card-hover group"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="w-16 h-16 bg-[#30D5C8]/10 rounded-xl flex items-center justify-center group-hover:bg-[#30D5C8]/20 transition-colors group-hover:scale-110 transition-transform">
                  <industry.icon className="text-[#30D5C8]" size={32} />
                </div>
                <h3 className="font-['Montserrat'] font-bold text-lg text-[#F5F7F8]">
                  {industry.name}
                </h3>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};